'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var TICKET = exports.TICKET = 'TICKET';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/crm-object-lifecycle-update/constants/objectTypes.js
// module id = 750
// module chunks = 2 3